import { render, staticRenderFns } from "./salesDetail.vue?vue&type=template&id=12388178"
import script from "./salesDetail.vue?vue&type=script&lang=js"
export * from "./salesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports